"use strict";

exports.__esModule = true;
exports.formatStatus = formatStatus;
exports.formatTicketDataToCSV = void 0;
exports.formatTicketPriority = formatTicketPriority;
exports.formatTicketTypeList = formatTicketTypeList;
exports.formatTicketTypeListFn = formatTicketTypeListFn;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../../Theme");
var _DataTableContextMenu = require("../DataTableContextMenu");
var _FormattedPlantDate = require("../../../Time/FormattedPlantDate");
var _Utils = require("../../../../Utils");
var _isValidEmail = require("../../../User/isValidEmail");
var _constants = require("../../../Logbook/constants");
var _libCalendar = require("@vimana/lib-calendar");
var _constants2 = require("../../../Ticketing/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TicketType = _styledComponents["default"].span.withConfig({
  displayName: "ticketing__TicketType",
  componentId: "sc-80s3wv-0"
})(["color:", ";padding:2px;border-radius:3px;margin-right:2px;background:", ";"], (0, _Theme.val)("inverseTextColor"), function (props) {
  return props.color;
});
/**
 * For the data value apply the formatting preferences to the value
 */
function formatTicketTypeListFn(tickets, columnSettings, ticketTypes) {
  if (!Array.isArray(tickets)) {
    tickets = [tickets];
  }

  // filter the list of ticket types down to the ones being formatted
  var filtered = tickets.map(function (id) {
    return ticketTypes.ticketTypes.find(function (t) {
      return t.id === id;
    });
  }).filter(function (t) {
    return t && t.id !== undefined;
  });
  return filtered.map(function (t) {
    return t.value;
  });
}

/**
 * For the data value apply the formatting preferences to the value
 */
function formatTicketTypeList(tickets, columnSettings, ticketTypes) {
  if (!Array.isArray(tickets)) {
    tickets = [tickets];
  }

  // filter the list of ticket types down to the ones being formatted
  var filtered = tickets.map(function (id) {
    return ticketTypes.ticketTypes.find(function (t) {
      return t.id === id;
    });
  }).filter(function (t) {
    return t && t.id !== undefined;
  });
  return filtered.map(function (t) {
    return /*#__PURE__*/_react["default"].createElement(TicketType, {
      key: t.id,
      color: t.color
    }, t.value);
  });
}

/**
 * For the data value apply the formatting preferences to the value
 */
function formatTicketPriority(tickets, columnSettings, translate) {
  if (!Array.isArray(tickets)) {
    tickets = [tickets];
  }
  var filtered = tickets.map(function (id) {
    var _TICKET_PRIORITIES$fi;
    return (_TICKET_PRIORITIES$fi = _constants2.TICKET_PRIORITIES.find(function (t) {
      return t.id === id;
    })) != null ? _TICKET_PRIORITIES$fi : _constants2.TICKET_PRIORITIES[1];
  });
  return filtered.map(function (t) {
    return /*#__PURE__*/_react["default"].createElement(TicketType, {
      key: t.id,
      color: t.color
    }, translate("DataTable.TicketPriority." + t.id, t.id));
  });
}
var STATUS_MAP = null;
function formatStatus(status, columnSettings, translate) {
  if (!STATUS_MAP) {
    STATUS_MAP = {
      OPEN: translate("DataTable.Status.Open", "Open"),
      IN_PROGRESS: translate("DataTable.Status.InProgress", "In Progress"),
      CLOSED: translate("DataTable.Status.Closed", "Closed")
    };
  }
  return STATUS_MAP[status] || "";
}
var formatTicketDataToCSV = exports.formatTicketDataToCSV = function formatTicketDataToCSV(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    timezone = _ref.timezone,
    users = _ref.users;
  var _getFormattedData = (0, _DataTableContextMenu.getFormattedData)(columns, data),
    headers = _getFormattedData.headers,
    rows = _getFormattedData.rows;
  var maxCommentColumns = 0;
  rows = rows.map(function (row) {
    // The id in row is wrapped with `"` exportDataToCSVFormat hence in order to get ticketId we remove the "'s
    var ticketId = row[0].replaceAll("\"", "");
    var comments = getTicketComments(data, ticketId);
    maxCommentColumns = Math.max(maxCommentColumns, comments.length);
    var formattedComments = comments.map(getCommentFormatter({
      timezone: timezone,
      users: users
    }));
    return [].concat(row, formattedComments);
  });
  for (var i = 1; i <= maxCommentColumns; i++) {
    headers.push("Comment " + i);
  }
  return {
    headers: headers,
    rows: rows
  };
};
var getCommentFormatter = function getCommentFormatter(_ref2) {
  var timezone = _ref2.timezone,
    users = _ref2.users;
  return function (_ref3) {
    var author = _ref3.author,
      body = _ref3.body,
      timestamp = _ref3.timestamp;
    var user = users.getUser(author.value) || users.getUserByEmail(author.value);
    var creator;
    if (user) {
      creator = (0, _Utils.formatUserName)(user);
    } else if ((0, _isValidEmail.isValidEmail)(author.value)) {
      creator = author.value;
    } else {
      creator = _constants.INTERNAL_USER;
    }
    var createdAt = (0, _FormattedPlantDate.formatDateString)(timestamp, {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      year: "numeric",
      timeZone: timezone.name
    });
    return "\"Author: " + creator + " \nCreated: " + createdAt + " \nDescription: " + body + "\"";
  };
};
var getTicketComments = function getTicketComments(data, ticketId) {
  var ticket = data.find(function (ticket) {
    return ticket.id === ticketId;
  });
  return ticket ? ticket.comments : [];
};